import emailjs from "emailjs-com";

const EMAILJS_USER_ID = "zXU72GrPb2Qv-YlTF";

emailjs.init(EMAILJS_USER_ID);

export default emailjs;
